export const ANALYTICS_SOURCE = 'assistant';
export const ANALYTICS_SCHEMA_VERSION = 1;

export const ASSISTANT_ANALYTICS_EVENTS = {
  SESSION_STARTED: 'assistant.session.started',
  QUERY_SUBMITTED: 'assistant.query.submitted',
  TURN_COMPLETED: 'assistant.turn.completed',
  TOOL_INVOKED: 'assistant.tool.invoked',
  SEARCH_EXECUTED: 'assistant.search.executed',
  KNOWLEDGE_RESOLVED: 'assistant.knowledge.resolved',
  QC_INVOKED: 'assistant.qc.invoked',
  FEEDBACK_GIVEN: 'assistant.feedback.given',
  ERROR_OCCURRED: 'assistant.error.occurred',
} as const;

export const CHAT_ANALYTICS_EVENTS = ASSISTANT_ANALYTICS_EVENTS;

export type AssistantAnalyticsEvent =
  typeof ASSISTANT_ANALYTICS_EVENTS[keyof typeof ASSISTANT_ANALYTICS_EVENTS];

export type ChatAnalyticsEvent = AssistantAnalyticsEvent;

export function getAnalyticsDomain(eventName: AssistantAnalyticsEvent): string {
  return eventName.split('.')[1] || 'unknown';
}

export function getAnalyticsAction(eventName: AssistantAnalyticsEvent): string {
  return eventName.split('.')[2] || eventName;
}
